// extracted by mini-css-extract-plugin
module.exports = {"template-icon":"TemplateMsgItem_template-icon__Jo5ug","templateItem":"TemplateMsgItem_templateItem__diqtS","category-translation":"TemplateMsgItem_category-translation__itwna"};